import React from 'react';
import { Badge, BadgeVariant } from './Badge.tsx';
import { Icon } from './Icon.tsx';

const NativeButton = 'button';

export interface StatusOption<T> {
    value: T;
    label: string;
    variant?: BadgeVariant;
    icon?: string;
    className?: string;
}

interface StatusToggleProps<T extends string | number> {
    value: T;
    options: StatusOption<T>[];
    onChange: (newValue: T) => void;
    className?: string;
    size?: 'sm' | 'md';
    disabled?: boolean;
}

export const StatusToggle = <T extends string | number>({ 
    value, 
    options, 
    onChange, 
    className = '',
    size = 'md',
    disabled = false
}: StatusToggleProps<T>) => {
    
    // Find current option or default to first
    const currentIndex = options.findIndex(o => o.value === value);
    const actualIndex = currentIndex !== -1 ? currentIndex : 0;
    const currentOption = options[actualIndex]!;


    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        
        const nextIndex = (actualIndex + 1) % options.length;
        onChange(options[nextIndex]!.value);

    };

    return (
        <NativeButton
            onClick={handleClick}
            className={`focus-ring rounded-full transition-transform ${!disabled ? 'cursor-pointer active:scale-95' : 'cursor-not-allowed opacity-70'} ${className}`}
            title={disabled ? undefined : "Click to toggle status"}
            type="button"
            disabled={disabled}
        >
            <Badge 
                variant={currentOption.variant || 'secondary'} 
                size={size}
                className={`flex select-none items-center gap-1 ${currentOption.className || ''}`}
            >
                {currentOption.icon ? <Icon name={currentOption.icon} size="xs" /> : null}
                {currentOption.label}
            </Badge>
        </NativeButton>
    );
};














